var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPostIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    rx: 10,
    fill: "#45D56D"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3312_19143)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3312_19143",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 11,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0015 11.998H45.0015V43.998H13.0015V11.998Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3312_19143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0384 15.9476C38.0384 15.1488 37.7211 14.3826 37.1562 13.8172C36.5909 13.2524 35.8247 12.9351 35.0259 12.9351H22.9759C22.1771 12.9351 21.4109 13.2524 20.8456 13.8172C20.2807 14.3826 19.9634 15.1488 19.9634 15.9476V40.0476C19.9634 40.8464 20.2807 41.6126 20.8456 42.1779C21.4109 42.7427 22.1771 43.0601 22.9759 43.0601H35.0259C35.8247 43.0601 36.5909 42.7427 37.1562 42.1779C37.7211 41.6126 38.0384 40.8464 38.0384 40.0476V15.9476Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0384 16.9518H19.9634V31.0101L22.9759 27.9976L26.4904 31.5122L35.0259 22.9768L38.0384 25.9893V16.9518Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9805 38.0393L24.9847 39.0435L25.9888 38.0393",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9805 34.0229L35.0263 22.9771L38.0388 25.9896V34.0229H23.9805Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9634 31.0104L22.9759 27.998L26.4905 31.5125L23.9801 34.0229H19.9634V31.0104Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9883 20.9692C27.0969 20.9692 27.9966 21.8689 27.9966 22.9775C27.9966 24.0861 27.0969 24.9858 25.9883 24.9858C24.8797 24.9858 23.98 24.0861 23.98 22.9775C23.98 21.8689 24.8797 20.9692 25.9883 20.9692Z",
    stroke: "white",
    strokeWidth: 1.875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3312_19143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostIcon);
export default __webpack_public_path__ + "static/media/PostIcon.4c87d63f796f41773664caec135546d8.svg";
export { ForwardRef as ReactComponent };